import {z} from 'zod';

/**
 * Deploy-gap stopgap: the field's real contract is the receiver schema, but the backend
 * that sends it has not been deployed yet, so tolerate the key being absent or null until
 * then. A cleanup bot unwraps this call once the YouTrack issue reaches Fixed (= live in
 * prod); a `.default(null)` chained after it has to be removed by hand in the same pass.
 * Side-effect module: import it once per app entry point and test setup.
 */
function optionalUntilDeployed<T extends z.ZodType>(
    this: T,
    youtrackIssue: `${string}-${number}`,
): z.ZodOptional<z.ZodNullable<T>> {
    return this.nullish().meta({youtrackIssue});
}

// zod's $constructor types prototype as any, so the assertion keeps no-unsafe-member-access quiet
(z.ZodType as unknown as {prototype: z.ZodType}).prototype.optionalUntilDeployed =
    optionalUntilDeployed;

declare module 'zod' {
    interface ZodType {
        optionalUntilDeployed(
            youtrackIssue: `${string}-${number}`,
        ): z.ZodOptional<z.ZodNullable<this>>;
    }
}
